// extracted by mini-css-extract-plugin
module.exports = {"align":"AnswerCondition_align__161Ew"};